import * as React from 'react';
type Props = {
  className?: string;
};
export function SpiceMedium({ className }: Props) {
  return (
    <svg
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="illustrated-Spice medium"
      className={className}
    >
      <path
        d="M30.9038 17.3327C31.5676 16.5243 32.3098 15.4737 32.9793 14.1688C34.112 11.965 34.5845 9.91714 34.7979 8.47021M21.6823 19.2151C23.5014 19.8325 26.3731 21.0941 28.9222 23.6958C29.8373 24.6303 30.5439 25.5668 31.0881 26.4164M18.1551 2.85712C14.3773 6.04985 18.8662 9.74726 16.4532 13.5177M13.0814 8.14558C9.30368 11.3383 13.7926 15.0357 11.3796 18.8062M7.41608 15.8017C3.63833 18.9945 8.12724 22.6919 5.71423 26.4624M29.0758 16.3708C36.5316 19.3159 29.789 29.8122 26.1335 32.8466C22.8515 35.5708 18.9297 36.957 14.7649 36.7737C13.6593 36.7262 7.03018 36.1035 7.11591 34.1608C7.1344 33.7314 8.27874 33.7516 10.4813 32.5695C15.0733 30.1022 16.1077 26.6137 18.8466 22.5393C20.8704 19.5284 25.0275 14.7721 29.0758 16.3708Z"
        stroke="currentColor"
      />
    </svg>
  );
}
